"use strict";

import MailToLink from "@threespot/mailto";

document.querySelectorAll("[data-email]").forEach(el => new MailToLink(el));

